import React, { useState } from 'react'
import { v4 } from 'uuid'
import { NIA_LOGIN_URL, NIA_STATE_URL, SUKL_USERS_URL } from '../api/settings'
import Header from '../layout/Header'

const LoginTest = () => {

  const [niaLoginUrl, setNiaLoginUrl] = useState<string>(NIA_LOGIN_URL ?? '')
  const [niaStateUrl, setNiaStateUrl] = useState<string>(NIA_STATE_URL ?? '')
  const [spUrl, setSpUrl] = useState<string>(SUKL_USERS_URL ?? '')
  const [uuid, setUuid] = useState<string>(v4())
  const [target, setTarget] = useState<string>(window.location.pathname)
  const [redirect, setRedirect] = useState<boolean>(true)

  const [bearerToken, setBearerToken] = useState<string>('eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiIDogIkVJIEFVVEggSldUIiwgImlhdCIgOiAxNzU5ODIxNzI0LCAiZXhwIiA6IDE3NTk5NjA4MDAsICJhdWQiIDogIiouc3VrbC5jeiIsICJzdWIiIDogIk9qRTFNREEwTWprMk9EbzNNMkV4WXpBNE1DMWlNRGt3TFRSaU9URXRZV1ZoTmkxaFpEQmhPVGhqTXpBelpXUT0ifQ.PFwkqYMTQuxo8n_PfwanwUR5vLFdLDn6-rrjCSDLnpg')

  const [responseStav, setResponseStav] = useState<any>(null)
  const [responseToken, setResponseToken] = useState<any>(null)
  const [responseOsoba, setResponseOsoba] = useState<any>(null)
  const [responseAuth, setResponseAuth] = useState<any>(null)

  const [errorStav, setErrorStav] = useState<any>(null)
  const [errorToken, setErrorToken] = useState<any>(null)
  const [errorOsoba, setErrorOsoba] = useState<any>(null)
  const [errorAuth, setErrorAuth] = useState<any>(null)

  const [osobaId, setOsobaId] = useState<string>('')

  const loginUrl = `${niaLoginUrl}/login/${uuid}/osoba/0?redirect=${redirect ? 'true' : 'false'}&target=${encodeURIComponent(target)}`
  const stavUrl = `${niaStateUrl}/stav/${uuid}`
  const tokenUrl = `${niaStateUrl}/token/${uuid}`
  const osobaUrl = `${spUrl}/osoba/${osobaId}`
  const authUrl = `${spUrl}/auth `

  const headers = { 'Authorization': `Bearer ${bearerToken}` }
  const clickStav = async () => {
    setErrorStav(null)
    setResponseStav(null)
    try {
      const res = await fetch(stavUrl)
      setResponseStav(await res.json())
    } catch (e) {
      console.log(e)
      setErrorStav(e.toString())
    }
  }

  const clickToken = async () => {
    setErrorToken(null)
    setResponseToken(null)
    try {
      const res = await fetch(tokenUrl)
      setResponseToken(await res.json())
    } catch (e) {
      console.log(e)
      setErrorToken(e.toString())
    }
  }

  const clickOsoba = async () => {
    setErrorOsoba(null)
    setResponseOsoba(null)
    try {
      const res = await fetch(osobaUrl, {
        headers: headers
      })
      setResponseOsoba(await res.json())
    } catch (e) {
      console.log(e)
      setErrorOsoba(e.toString())
    }
  }

  const clickAuth = async () => {
    setErrorAuth(null)
    setResponseAuth(null)
    try {
      const res = await fetch(authUrl, {
        headers: headers
      })
      setResponseAuth(await res.json())
    } catch (e) {
      console.log(e)
      setErrorAuth(e.toString())
    }
  }

  const generateUuid = () => {
    setUuid(v4())
  }

  return (
    <>
      <Header/>
      <div className="page-content">
        <h1>Login test</h1>

        <fieldset>
          <label>NIA LOGIN URL</label>
          <input style={{ width: 500 }} type="text" value={niaLoginUrl}
                 onChange={event => setNiaLoginUrl(event.target.value)}/>

          <fieldset>
            <label>UUID</label>
            <input style={{ width: 500 }} type="text" value={uuid} onChange={event => setUuid(event.target.value)}/>
            <button onClick={generateUuid}>Generate UUID</button>

            <fieldset>

              <label>Target</label>
              <input style={{ width: 500 }} type="text" value={target}
                     onChange={event => setTarget(event.target.value)}/>
              <br/>
              <input type="checkbox" checked={redirect} onChange={event => setRedirect(event.target.checked)}/> Redirect
              <br/>
              Login: <a href={loginUrl}>{loginUrl}</a>
            </fieldset>

          </fieldset>
          <fieldset>
            <label>NIA STATE URL</label>
            <input style={{ width: 500 }} type="text" value={niaStateUrl}
                   onChange={event => setNiaStateUrl(event.target.value)}/>

            <fieldset>
              <small>{stavUrl}</small>
              <br/>
              <button onClick={clickStav}>GET stav</button>
              {errorStav && <pre style={{ color: 'red' }}>{JSON.stringify(errorStav, null, 2)}</pre>}
              {responseStav && <pre>{JSON.stringify(responseStav, null, 2)}</pre>}
            </fieldset>
            <fieldset>
              <small>{tokenUrl}</small>
              <br/>
              <button onClick={clickToken}>GET token</button>
              {errorToken && <pre style={{ color: 'red' }}>{JSON.stringify(errorToken, null, 2)}</pre>}
              {responseToken && <pre>{JSON.stringify(responseToken, null, 2)}</pre>}

            </fieldset>
          </fieldset>


        </fieldset>

        <fieldset>
          <label>SP URL</label>

          <input style={{ width: 500 }} type="text" value={spUrl} onChange={event => setSpUrl(event.target.value)}/>
          (org: https://t-sp-ei01.sukl.cz/sp/v1)
          (proxy: https://tformulare.sukl.cz/sp)

          <fieldset>
            <label>Bearer token</label>
            <input style={{ width: 800 }} type="text" value={bearerToken}
                   onChange={event => setBearerToken(event.target.value)}/>

            <small>{authUrl}</small> / <small>{JSON.stringify(headers)}</small>
            <br/>
            <button onClick={clickAuth}>GET auth</button>
            {errorAuth && <pre style={{ color: 'red' }}>{JSON.stringify(errorAuth, null, 2)}</pre>}
            {responseAuth && <pre>{JSON.stringify(responseAuth, null, 2)}</pre>}


            <br/>
            <br/>

            <label>Osoba Id</label>
            <input style={{ width: 800 }} type="text" value={osobaId}
                   onChange={event => setOsobaId(event.target.value)}/>
            <br/>

            <small>{osobaUrl}</small> / <small>{JSON.stringify(headers)}</small>
            <br/>

            <button onClick={clickOsoba}>GET osoba</button>
            {errorOsoba && <pre style={{ color: 'red' }}>{JSON.stringify(errorOsoba, null, 2)}</pre>}
            {responseOsoba && <pre>{JSON.stringify(responseOsoba, null, 2)}</pre>}
          </fieldset>
        </fieldset>

      </div>
    </>
  )
}

export default LoginTest
